import { render, staticRenderFns } from "./Premio.vue?vue&type=template&id=09ad6f1a"
import script from "./Premio.vue?vue&type=script&lang=js"
export * from "./Premio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports